import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/AnimalInventoryForm";
import { ANIMAL_TYPE_GOAT } from "variables/constants";

const EditGoat = () => {
	const { goatId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<RegisteredAnimalsForm recordId={goatId ?? 0} mode="edit" animalTypeId={ANIMAL_TYPE_GOAT}/>
	      </div>
	    </div>
    );
};

export default EditGoat;